import {EditProps} from "react-admin";
import {DefaultEdit} from "../../components/DefaultEdit";
import {WorkPermitTypeForm} from "./WorkPermitTypeForm";


export const WorkPermitTypeEdit = (props: EditProps) => {
    return (
        <DefaultEdit {...props} >
            <WorkPermitTypeForm/>
        </DefaultEdit>
    );
}